module.exports = __webpack_public_path__ + "img/analyt-icon.a2bff94f.svg";